interface InitOptions {
    zones: {[key: string]: string[]};
    domains: {[key: string]: string[]};
}

interface ValidationResult {
    valid: boolean;
    suggestion?: string;
}

export default class AitiCoreValidatorEmail {

    static EVENT_INIT_AFTER = 'aiticore_validator_email_init_after';

    private _options: InitOptions;

    getClient() {
        return AitiCore.getClients().getFoxentryClient();
    }

    init(options: InitOptions): JQuery.Deferred<void> {
        this._options = options;

        return this.getClient().init().done(function() {
            DeferredEvents.trigger(AitiCoreValidatorEmail.EVENT_INIT_AFTER);
        });
    }

    validateFull(value: string): JQuery.Deferred<ValidationResult> {
        let deferred = jQuery.Deferred();

        this.validateDomain(value).done((result) => {
            if (!result.valid || result.suggestion) {
                deferred.resolve(result);
                return;
            }

            this.getClient().validateEmail(value).done((result) => {
                deferred.resolve({
                    valid: result.isValid(),
                    suggestion: result.getHintValue(),
                });
            }).fail(() => {
                deferred.reject();
            });
        }).fail(() => {
            deferred.reject();
        });

        return deferred;
    }

    validateDomain(value: string): JQuery.Deferred<ValidationResult> {
        let deferred = jQuery.Deferred();
        let suggestion: string;

        value = '' + value;

        out: {
            for (let key in this._options.domains) {
                for (let find of this._options.domains[key]) {
                    if (value.indexOf('@' + find + '.') != -1) {
                        suggestion = value.replace(find, key);
                        break out;
                    }
                }
            }
        }

        out: {
            for (let key in this._options.zones) {
                for (let find of this._options.zones[key]) {
                    if (value.endsWith('.' + find)) {
                        suggestion = suggestion ? suggestion.replace(find, key) : value.replace(find, key);
                        break out;
                    }
                }
            }
        }

        deferred.resolve({
            valid: !suggestion,
            suggestion: suggestion,
        });

        return deferred;
    }

    /**
     * Validates e-mail address based on RFC 2822
     * @link https://stackoverflow.com/a/1373724
     */
    validateFormat(value: string): boolean {
        let regex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
        return regex.test(value);
    }

    onInitAfter(handler: (event: DeferredEvent) => any, priority: number = DeferredEvents.PRIORITY_NORMAL, ignoreCancel: boolean = false) {
        DeferredEvents.listen(AitiCoreValidatorEmail.EVENT_INIT_AFTER, handler, priority, ignoreCancel, this);
        return this;
    }
}
